import React, { Component } from "react";
import PropTypes from 'prop-types';
import { graphql, Link } from "gatsby";
import Layout from "../components/layout";
// import { Card, CardImg, CardBody, CardTitle, CardText } from 'reactstrap'

class HomeLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            props: props,
            page: props.data.dataJson,
            guests: 2,
            rooms: 1,
            arrival: new Date(),
            departure: new Date() + 1
        }
        // console.log(props);
    }
    componentDidMount() {
        var date = new Date();
        var arrival = date.getDate() + "/" + date.getMonth() + 1 + "/" + date.getFullYear();
        date.setDate(date.getDate() + 1);
        var departure = date.getDate() + "/" + date.getMonth() + 1 + "/" + date.getFullYear();
        this.setState({ arrival: arrival, departure: departure });

    }
    render() {
        return (
            <Layout>
                <section className="header" style={{ backgroundColor: "#78909c", backgroundImage: `url(${this.state.page.titleBackground})` }} data-scrim-top="9">
                    <div className="container text-left mt-4">
                        <span className="text-white caps_large underline-primary">middle-market private equity</span>
                        <h3 className="home_header text-white">IEP are a highly experienced team of professionals with global and domestic expertise.</h3>
                        <Link to="/about-us" className="btn text-white bg-secondary">Find Out More <i className="fa fa-long-arrow-right text-white"></i></Link>
                        <div className="square-menu">
                            <div className="row">
                                <div className="col-md-12 p-0">
                                    <ul>
                                        <li className="wpb_column vc_column_container col-lg-4 col-sm-10">
                                            <div >
                                                <span><i className="fa fa-handshake-o text-white float-left"></i> <h5 className="ml-9">Our Investment<br />Philosophy</h5></span>
                                                <Link to="/about-us" className="btn text-white bg-secondary btn-secondary-outline homebtn">Know More <i className="fa fa-long-arrow-right text-white"></i></Link>
                                            </div>
                                        </li>
                                        <li className="wpb_column vc_column_container col-lg-4 col-sm-10">
                                            <span><i className="fa fa-users text-white float-left"></i> <h5 className="ml-9">Leadership Team and Advisory Board</h5></span>
                                            <Link to="/leadership-team-and-advisory-board" className="btn text-white bg-secondary btn-secondary-outline homebtn">Know More <i className="fa fa-long-arrow-right text-white"></i></Link>
                                        </li>
                                        <li className="wpb_column vc_column_container col-lg-4 col-sm-10" style={{ borderRight: "none" }}>
                                            <span><i className="fa fa-line-chart text-white float-left"></i> <h5 className="ml-9">Investment Warehouse</h5></span>
                                            <Link to="/investment-warehouse" className="btn text-white bg-secondary btn-secondary-outline homebtn">Know More <i className="fa fa-long-arrow-right text-white"></i></Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-8 bg-white">
                                <h3>Indus Equity Partners (IEP) is an India focused VC tech fund manager with a focus on med tech / health sciences and fin tech.</h3>
                                <h3>We have warehoused investments across these areas in our deal pipeline.</h3>
                            </div>
                            <div className="col-md-4 bg-secondary">
                                <Link to="/investment-warehouse/cancer-screening">
                                    <div className="media mt-2" style={{ borderBottom: "1px solid white" }}>
                                        <img className="align-self-start mr-3 w-20 rounded-lg shadow-6" src="https://cdn.hummz.it/indusequitypartners/cancer-screening-1.jpg" alt="Cancer Screening" />
                                        <div className="media-body text-white">
                                            <h5 className="my-0">Cancer Screening</h5>
                                            <p className="mt-0 font-size-14">A company developing affordable biophotonic medical devices for early cancer detection. <strong>Know more...</strong></p>
                                        </div>
                                    </div>
                                </Link>
                                <Link to="/investment-warehouse/disrupting-digital-payments">
                                    <div className="media mt-2">
                                        <img className="align-self-start mr-3 w-20 rounded-lg shadow-6" src="https://cdn.hummz.it/indusequitypartners/disrupting-digital-payments.jpg" alt="Disrupting Digital Payments" />
                                        <div className="media-body text-white">
                                            <h5 className="my-0">Disrupting Digital Payments</h5>
                                            <p className="mt-0 font-size-14">Disrupting digital payments with patented technology for offline & online mobile payments. <strong>Know more...</strong></p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section py-7 bg-secondary">
                    <div className="container">
                        <div className="row gap-y align-items-center">
                            <div className="col-md-4">
                                <h3 className="mb-0 text-white text-center text-md-left">Our Sector Knowledge</h3>
                            </div>
                            <div className="col-md-8 text-center text-md-center gap-xy">
                                <Link to="/investment-warehouse" className="btn btn-link btn-round btn-light text-white font-size-14">Healthcare</Link>
                                <Link to="/investment-warehouse" className="btn btn-link btn-round btn-light text-white font-size-14">Consumers</Link>
                                <Link to="/investment-warehouse" className="btn btn-link btn-round btn-light text-white font-size-14">Technology</Link>
                                <Link to="/investment-warehouse" className="btn btn-link btn-round btn-light text-white font-size-14">Niche Manufacturing</Link>
                                <Link to="/investment-warehouse" className="btn btn-link btn-round btn-light text-white font-size-14">BFSI</Link>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section py-7 bg-pale-primary lead p-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-10 mx-auto">
                                <div className="row col-12 justify-content-left">
                                    <h2>Leadership Team</h2>
                                </div>
                                <div className="row gap-y gap-4 justify-content-center">
                                    <div className="col-md-6 col-lg-3 rounded-lg team-1 border m-2 shadow-2 hover-shadow-9">
                                        <Link to="/leadership-team-and-advisory-board/rajiv-bhatia">
                                            <img src="https://cdn.hummz.it/indusequitypartners/rajiv-bhatia.png" alt="Rajiv Bhatia" className="img-fluid rounded-lg bg-white" style={{ height: "250px" }} />
                                            <h6>Rajiv Bhatia</h6><small>Managing Partner</small>
                                        </Link>
                                    </div>
                                    <div className="col-md-6 col-lg-3 rounded-lg team-1 border m-2 shadow-2 hover-shadow-9">
                                        <Link to="/leadership-team-and-advisory-board/sumit-kochhar">
                                            <img src="https://cdn.hummz.it/indusequitypartners/sumit-kochhar.png" alt="Sumit Kochhar" className="img-fluid rounded-lg bg-white" style={{ height: "250px" }} />
                                            <h6>Sumit Kochhar</h6><small>Partner</small>
                                        </Link>
                                    </div>
                                    <div className="col-md-6 col-lg-3 rounded-lg team-1 border m-2 shadow-2 hover-shadow-9">
                                        <Link to="/leadership-team-and-advisory-board/samir-pandey">
                                            <img src="https://cdn.hummz.it/indusequitypartners/samir-pandey.png" alt="Samir Pandey" className="img-fluid rounded-lg bg-white" style={{ height: "250px" }} />
                                            <h6>Samir Pandey</h6><small>Chief Investment Officer</small>
                                        </Link>
                                    </div>
                                    <div className="row col-12 justify-content-center"><br /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        )
    }
}

export const query = graphql`
  query($slug: String!) {
    dataJson(fields: { slug: { eq: $slug } }) {
      title
      subTitle
      titleBackground
      contents {
         heading
         image
         imageLeft
         content
         link
       }
    }
  }
`

HomeLayout.propTypes = {
    data: PropTypes.object
};

React.defaultProps = {
    className: 'react-remark',
};

export default HomeLayout;
